import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import UserSelect from "../UserSelect/UserSelect.vue";
import { mapGetters, mapActions } from "vuex";

export default {
    name: "EnvoiUnitaireLetRecoElec",
    components: { UserSelect },
    mixins: [validationMixin],
    props: ['category'],
    computed: {
        ...mapGetters(["auth"]),
        isAdmin() {
            if(this.auth && this.auth.user && this.auth.user.roles && 
                this.auth.user.roles.find((role) => role.name === "admin")) {
                return true
            }
            return false
        },
    },
    data() {
        return {
            dragging: false,
            envoiEnCours: false,
            downloadAck: false,
            fileUploading: false,
            files: [],
            objectURL: '',
            destinataire: {
                nom: '',
                prenom: '',
                mail: '',
                societe: '',
                adresse: '',
                ville: '',
                codePostal: '',
                civilite: '',
                numero: '',
                commentaire: '',
            },
            emetteur: {}
        };
    },
    mounted() {
        this.emetteur = this.auth.user;
    },
    methods: {
        ...mapActions([
            'uploadFiles', 'createCommandeUnitaire'
        ]),   
        validerEtEnregister() {
            this.$v.destinataire.$touch();
            if (this.$v.destinataire.$anyError || this.files.length === 0) {
              return;
            }
            this.envoiEnCours = true;
            let formData = new FormData();
            this.files.forEach((file,index) => {
                formData.append('file'+index, file);
            });
            this.uploadFiles(formData).then(response => {
                let documents = response.data;
                let commande = {
                    produitSelect: this.category.categorie_id,
                    sousCatSelect: this.category.id,
                    numero: this.destinataire.numero,
                    reference: '',
                    destinataire: this.destinataire,
                    documents: documents,
                    emetteur: this.emetteur,
                }
                this.createCommandeUnitaire(commande).then(response => {
                    this.envoiEnCours = false;
                    this.$emit('commandeCréée');
                    this.$toasted.show("Commande enregistré.", {
                        icon: {
                            name: 'check-circle',
                        },
                        theme: "outline",
                        position: "bottom-center",
                        duration : 2000
                    });
                });
            })
        },
        addFile(event) {
            if (event.dataTransfer && event.dataTransfer.files) {
                Array.from(event.dataTransfer.files).forEach(f => {this.files.push(f)});
            }
            else if (event.target && event.target.files) {
                Array.from(event.target.files).forEach(f => {this.files.push(f)});
                event.target.value = ''
            }            
        },
        previewElement(file){
            let fileObject = this.files.find(el => {return el.name === file.name});
            this.objectURL = window.URL.createObjectURL(fileObject);
            this.$refs.objectURLviewer.show();
        },
        sendFiles(files) {
            this.dragging = false;
            this.fileSelect = 0;
        },
        validateState(name) {
            const { $dirty, $error } = this.$v.destinataire[name];
            return $dirty ? !$error : null;
        },
    },
    filters: {
    },
    watch: {
    },
    validations: {
        destinataire: {
            civilite: {required},
            nom: {required},
            prenom: {required},
            mail: {required,email},
            adresse: {required},
            ville: {required},
            societe: {},
            codePostal: {required},
            numero: {required},
            commentaire: {},
        }
    },
};
